import {GetSeferData} from "SeferPetach/GetData";

export async function getFileList() {
    var args = {
        'TYPE_ID': 9,
        'ITEM_STATUS': 1
    };
    var payload = await GetSeferData("af3", args);
    return (payload);
}

export async function getFileByID(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af4", args);
    return (payload);
}

export async function updateFile(obj) {
    var args        = obj;
    var payload     = await GetSeferData("af1", args);
    return (payload);
}

export async function deleteFile(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af5", args);
    return (payload);
}